// src/pages/Callback.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { parseObservations } from "../../utils/parseObservations";
import { noDuplicateEntries } from "../../utils/noDuplicateEntries";
import { createObservationsBulk } from "../../api/observationsApi";

export default function Callback() {
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        if (!code) {
            console.error("No authorization code found");
            return;
        }

        // Exchange code for token
        const tokenUrl = "https://launch.smarthealthit.org/v/r4/sim/WzMsIiIsIiIsIkFVVE8iLDAsMCwwLCIiLCIiLCIiLCIiLCIiLCIiLCIiLDAsMSwiIl0/auth/token";
        const redirectUri = encodeURIComponent(`${window.location.origin}/callback`);

        fetch(tokenUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
                grant_type: "authorization_code",
                code,
                redirect_uri: redirectUri,
                client_id: "my_web_app",
            }),
        })
            .then((res) => res.json())
            .then(async (data) => {
                console.log("Token Response:", data);
                localStorage.setItem("accessToken", data.access_token);
                localStorage.setItem("patientId", data.patient);

                const obsRes = await fetch(`https://launch.smarthealthit.org/v/r4/sim/WzMsIiIsIiIsIkFVVE8iLDAsMCwwLCIiLCIiLCIiLCIiLCIiLCIiLCIiLDAsMSwiIl0/fhir/Observation?subject=${data.patient}`);

                if (!obsRes.ok) {
                    throw new Error("Failed to fetch observations");
                }

                const obsData = await obsRes.json();

                const { vitals, labs } = parseObservations(obsData);
                const uniqueVitals = noDuplicateEntries(vitals);
                const uniqueLabs = noDuplicateEntries(labs);

                const uniqueVitalsWithCategory = uniqueVitals.map(v => ({ ...v, category: "vital" }));
                const uniqueLabsWithCategory = uniqueLabs.map(l => ({ ...l, category: "lab" }));

                const allObs = [...uniqueVitalsWithCategory, ...uniqueLabsWithCategory].map(obs => ({
                    patient_id: data.patient,
                    category: obs.category,
                    code: obs.id,
                    display_name: obs.label,
                    value: Number(obs.value) || 0,
                    unit: obs.unit?.slice(0, 32) || "",
                    effective_date: new Date(obs.date).toISOString().slice(0, 19).replace("T", " ")
                }));



                try {
                    const result = await createObservationsBulk(allObs);
                    console.log("Bulk observations created:", result);
                } catch (error) {
                    console.error("Error creating observations:", error);
                }

                navigate("/settings?tab=connected%20services");
            })
            .catch((err) => console.error("Token exchange failed", err));
    }, [navigate]);

    return <div>Completing connection...</div>;
}

